export default __webpack_public_path__ + "static/media/0x1599fe55cda767b1f631ee7d414b41f5d6de393d.094b14b4.png";